import React, { Component } from 'react';
export function Hero() {
  return <section className="relative bg-gray-900 py-24 md:py-32 lg:py-40" style={{
    backgroundImage: `url('https://cdn.magicpatterns.com/uploads/e5c8LH5KgbKR2gmVUa1nQW/hero-bg1.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-332">
      {/* Dark overlay - 75% opacity for readability */}
      <div className="absolute inset-0 bg-gray-900/75" data-id="element-333" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4" data-id="element-334">
        <div className="text-center max-w-4xl mx-auto" data-id="element-335">
          {/* Eyebrow - SEO statement */}
          <p className="text-sm md:text-base text-gray-300 font-medium tracking-wide uppercase mb-4" data-id="element-336">
            Industrial Bearings, Belts, Chain, Sprockets & Power Transmission
            Components
          </p>

          {/* H1 */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-337">
            <span className="text-red-500" data-id="element-338">USA</span>{' '}
            <span className="text-white" data-id="element-339">Bearings & Belts</span>
          </h1>

          {/* Support line - single sentence */}
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto" data-id="element-340">
            Supplying industrial, OEM, and maintenance professionals with
            quality components and bulk-order support nationwide.
          </p>
        </div>
      </div>
    </section>;
}